<template lang="pug">
	div
		filtro(:filtro="filtro", @buscar="buscarComisiones")
		resultados(:resultados="resultados")
</template>

<script>
import Filtro from './filtro'
import Resultados from './resultados'
import axios from 'axios'
export default {
	components: {
		filtro: Filtro,
		resultados: Resultados
	},
	data () {
		return {
			filtro: {
				AgenteNombre: null,
				Mes: new Date(),
				Estado: null
			},
			resultados: []
		}
	},
	methods: {
		buscarComisiones () {
			const form = JSON.parse(JSON.stringify(this.filtro))
			form.Mes = (this.filtro.Mes) ? Math.floor(this.filtro.Mes.getTime() / 1000) : null
			axios.post('facturacion-cobros/php/api/comisiones/buscar-comisiones.php', form)
				.then(res => {
					this.resultados = res.data
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/facturacion-cobros/vue/components/comisiones/index.vue